<template>
  <div>
    <custom-callout
      border-color="gray-5"
      class="mb-4 custom-callout-invoice"
      :has-toggle="false"
      :opened="toggleEditPanel"
    >
      <div class="row py-3">
        <div class="col-md-3">
          <div class="color-secondary-6 font-14">
            Fecha del Ajuste:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ formatDate(data.createdDate) }}
          </div>
        </div>
        <div class="col-md-5 mt-3 mt-md-0 mt-sm-3">
          <div class="color-secondary-6 font-14">
            Razón del Ajuste:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ data.reason }}
          </div>
        </div>
        <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
          <div class="color-secondary-6 font-14">
            Cantidad de Ajuste:
          </div>
          <div
            class="font-weight-bold font-16"
            :class="getAmountColor(data.amount)"
          >
            {{ getAdjustmentAmount(data.amount) }}
          </div>
        </div>
        <div class="col-md-2 mt-3 mt-md-0 mt-sm-3">
          <div class="color-secondary-6 font-14">
            Usuario:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ data.userFullName }}
          </div>
        </div>
      </div>
      <hr />
      <div class="row pb-3">
        <div class="col-md-8">
          <div class="color-secondary-6 font-14">
            Comentario del Ajuste:
          </div>
          <div class="color-black font-16 font-weight-normal">
            {{ data.comments }}
          </div>
        </div>
        <div class="col-12 offset-md-1 col-md-3 mt-3 text-right">
          <action-button
            v-if="canShowEdit"
            id="btn-edit-adjustment"
            class="success edit-btn mr-2"
            i="fa fa-edit"
            @click="onEditAdjustment()"
          />
          <action-button
            v-if="canShowDelete"
            id="btn-delete-adjustment"
            i="fas fa-minus-circle"
            variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
            @click="onDeleteAdjustment()"
          >
            Eliminar
          </action-button>
        </div>
      </div>
      <template v-if="toggleEditPanel" #edition>
        <div class="bg-secondary-3 p-3">
          <div class="bg-white rounded p-2 pl-4">
            <div class="row py-1">
              <div class="col-md-12">
                <div class="d-flex">
                  <span
                    class="dot d-flex justify-content-center align-items-center py-2 px-1 mt-2"
                  >
                    <i class="orange-icon orange-icon-badge-align fa fa-edit" />
                  </span>
                  <span
                    class="d-flex justify-content-center align-items-center py-1 px-1 mt-2 ml-2 font-weight-bold font-14"
                  >
                    Editar Ajuste
                  </span>
                </div>
              </div>
            </div>
            <validation-observer
              ref="editAdjustmentRef"
              class="pr-4"
              novalidate
              tag="form"
            >
              <div class="row mt-4">
                <div class="col-md-4">
                  <div class="font-14 color-gray-6 mb-1">
                    ¿Qué tipo de ajuste desea realizar?
                  </div>
                  <validation-provider v-slot="{ errors }" rules="required">
                    <custom-radio
                      :id="
                        `adjustment-adjustmentType-${data.requestAdjustmentId}-`
                      "
                      v-model="model.adjustmentType"
                      class="mt-3 radio-custom font-14"
                      custom-error-msg="El tipo de ajuste es requerido."
                      :error="Boolean(errors[0])"
                      is-inline
                      :name="`adjustmentType-${data.requestAdjustmentId}`"
                      :options="adjustmentOptions"
                    />
                  </validation-provider>
                </div>
                <div class="col-md-4 col-sm-12">
                  <div class="font-14 color-gray-6 mb-1">
                    Cantidad a ajustar:
                  </div>
                  <validation-provider
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'La cantidad es requerida.',
                      greaterThanZeroCustomMsg:
                        'La cantidad deber ser mayor a 0.',
                    }"
                    :rules="'required|greaterThanZero'"
                  >
                    <div class="input-group mb-3">
                      <custom-input
                        :id="`adjustment-amount-${data.requestAdjustmentId}`"
                        ref="adjustmentAmount"
                        v-model="model.amount"
                        class="w-70"
                        :class="getAmountClass"
                        custom-error-msg="La cantidad deber ser mayor a 0."
                        :error="errors[0]"
                        mask-type="Money"
                        placeholder="0.00"
                        :prepend-icon="getAmountIcon"
                        type="number"
                      />
                    </div>
                  </validation-provider>
                </div>
                <div class="col-md-4 text-right mt-3">
                  <action-button
                    i="fas fa-times-circle"
                    variant="outline-danger btn-cancel danger m-2 pl-4 pr-4"
                    @click="onCancelEditAdjustment()"
                  >
                    Cancelar
                  </action-button>
                  <action-button
                    i="fas fa-save"
                    variant="success pl-4 pr-4"
                    @click="onSaveEditAdjustment()"
                  >
                    Guardar
                  </action-button>
                </div>
              </div>
            </validation-observer>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
//libs components
import CustomCallout from 'custom-callout';
import moment from 'moment';
import ActionButton from 'ActionButton';
import CustomRadio from 'custom-radio';
import CustomInput from 'CustomInput';
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import disbursementRequestStatuses from '@/utils/shared/constants/disbursementRequestStatuses';

export default {
  name: 'ReinbursementAdjustment',
  components: {
    CustomCallout,
    ActionButton,
    CustomRadio,
    CustomInput,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    data: {
      type: Object,
      default: () => {},
    },
    statusId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      model: {
        amount: null,
        adjustmentType: null,
      },
      toggleEditPanel: false,
      adjustmentOptions: [
        {
          id: 1,
          name: 'rb-adjustmentType',
          value: 'positive',
          label: 'Positivo',
          check: false,
          invalid: false,
          disabled: false,
        },
        {
          id: 2,
          name: 'rb-adjustmentType',
          value: 'negative',
          label: 'Negativo',
          check: false,
          invalid: false,
          disabled: false,
        },
      ],
    };
  },
  computed: {
    getAmountColor() {
      return (amount) => (amount >= 0 ? 'color-primary-1' : 'color-primary-4');
    },
    getAdjustmentAmount() {
      return (amount) => {
        return amount > 0
          ? `${this.$options.filters.price(amount)}`
          : `-${this.$options.filters.price(Math.abs(amount))}`;
      };
    },
    getAmountIcon() {
      return this.model.adjustmentType &&
        this.model.adjustmentType.value == 'negative'
        ? 'fas fa-minus text-white'
        : 'fas fa-plus text-white';
    },
    getAmountClass() {
      return this.model.adjustmentType &&
        this.model.adjustmentType.value == 'negative'
        ? 'danger'
        : 'success';
    },
    canShowDelete() {
      return (
        this.statusId == disbursementRequestStatuses.ProcesoDeRevisión &&
        this.userHasPermissions('provider.disbursement.deleteadjustment')
      );
    },
    canShowEdit() {
      return (
        !this.toggleEditPanel &&
        this.statusId == disbursementRequestStatuses.ProcesoDeRevisión &&
        this.userHasPermissions('provider.disbursement.editadjustment')
      );
    },
  },
  methods: {
    formatDate: function(date) {
      if (date) {
        return moment(date)
          .locale('es')
          .format('DD/MMM/YYYY - hh:mma');
      }
      return '-';
    },
    onDeleteAdjustment() {
      this.$emit('on-delete', this.data.requestAdjustmentId);
    },
    onEditAdjustment() {
      this.toggleEditPanel = true;

      this.$nextTick(() => {
        const input = this.$refs.adjustmentAmount.$el.querySelector('input');
        input.value = parseFloat(Math.abs(this.data.amount)).toFixed(2);
        this.model.amount = Math.abs(this.data.amount);
      });

      this.model.adjustmentType =
        this.data.amount > 0
          ? this.adjustmentOptions[0]
          : this.adjustmentOptions[1];
    },
    onCancelEditAdjustment() {
      this.toggleEditPanel = false;
    },
    async onSaveEditAdjustment() {
      const isValid = await this.$refs.editAdjustmentRef.validate();

      if (!isValid) return;

      let payload = {
        requestAdjustmentId: this.data.requestAdjustmentId,
        amount: parseFloat(
          this.model.adjustmentType.value === 'negative'
            ? -Math.abs(this.model.amount)
            : Math.abs(this.model.amount)
        ),
      };

      this.$emit('on-edit', payload);
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';

::v-deep .edit-btn {
  i {
    margin: 0 !important;
  }
}

.dot {
  width: 25px;
  height: 25px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ff7058 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  padding-top: 9px;
  padding: 13px !important;
  border: 3px solid #fff;
}
.orange-icon {
  color: #ffffff;
  font-size: 10pt;
  padding-right: 4px;
  line-height: 25px;
  margin-left: 6px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

::v-deep .input-group-text {
  background-color: map-get($colors, 'green');
  border-color: map-get($colors, 'green');
}

.danger ::v-deep .input-group-text {
  background-color: map-get($colors, 'red');
  border-color: map-get($colors, 'red');
}

.radio-custom ::v-deep .col-12 {
  padding-left: 0;

  .custom-control-inline {
    margin-right: 3rem !important;
  }

  .custom-control-label {
    padding-top: 2px;
  }
}
</style>
